// src/pages/access-denied.tsx
import { Link } from 'react-router-dom';
import ButtonMailto from 'src/components/button-mailto';

const AccessDenied = () => {
  return (
    <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8 mt-4">
      <center>
        <h2 className='mb-3 text-lg font-bold'>Access Denied</h2>
        <h4>You do not have permission to view this page</h4>
        <p className="my-2">
           Please contact&nbsp;
          <span className="font-bold text-blue-700">
            <ButtonMailto
              label="sivunnaidu.gullipalli@brightspeed.com"
              mailto="mailto:sivunnaidu.gullipalli@brightspeed.com"
            />
          </span>
        </p>
      </center>
    </div>
  );
};

export default AccessDenied;
